import protoRoot from "../proto-root";

const name = "stopActivityLogRpcRequest";

function create() {
  const StopActivityLogRpcRequest = protoRoot.lookupType(
    "comm.StopActivityLogRpcRequest"
  );

  const payload = {};

  const request = StopActivityLogRpcRequest.create(payload);
  return { payload: request, name };
}

export default {
  create,
  name
};
